import styled from '@emotion/styled';
import { Colors, helperButtonReset, helperListItemHover, media } from '@utex/ui-kit';

export const Container = styled('div')`
  & + & {
    border-top: 1px solid ${Colors.ut.border10};
  }
`;

interface ItemProps {
  isActive?: boolean;
}

export const Item = styled('button')<ItemProps>`
  ${helperButtonReset};
  ${(props) => helperListItemHover({ isActive: props.isActive })};
  width: 100%;
  padding: 1.5rem var(--gap);
  text-align: left;

  @media ${media.phonablet} {
    padding: 1rem var(--gap);
  }
`;

export const Icon = styled('img')`
  flex-shrink: 0;
  width: 5rem;
  height: 5rem;
  margin-right: 2rem;

  @media ${media.mobile} {
    width: 3.6rem;
    height: 3.6rem;
    margin-right: 1.6rem;
  }
`;
